<template>
    <v-dialog v-model="model" max-width="600px" persistent>
        <v-card>
            <div class="pl-4 pr-3 py-3 primary">
                <div class="d-flex align-center justify-space-between">
                    <div class="d-flex align-center">
                        <v-icon size="12px" color="white" class="mr-2">fas fa-info fa-fw</v-icon> 
                        <div class="white--text font-weight-medium caption">INFO</div> 
                    </div>
                    <div>
                        <v-btn small text fab @click="$emit('accept')" class="my-0">
                            <v-icon small color="white">fa-times</v-icon> 
                        </v-btn>
                    </div>
                </div>
            </div>

            <v-divider></v-divider>

            <v-card-text class="py-8">
                <div class="px-4 black--text body-1 text-center" v-html="text"></div>
            </v-card-text>

            <div class="d-flex justify-end align-center pa-4">
                <v-btn text large class="accent" @click="$emit('accept')">Accept</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['model', 'text']
}
</script>

